



















import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import useUiState from '@shared/composables/useUiState';
import { BaseModal, UCIcon } from '@shared/ui';

import LoginSignUpForm from '~/components/AccountModal/LoginSignUpForm.vue';

export default defineComponent({
  name: 'AccountModal',
  components: {
    LoginSignUpForm,
    BaseModal,
    UCIcon,
  },
  props: {
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    userFullName: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { isAccountModalOpen, toggleAccountModal } = useUiState();
    const isSignUp = ref(false);

    const toggleSignUp = () => {
      isSignUp.value = !isSignUp.value;
    };

    const modalHeader = computed(() => {
      return isSignUp.value ? 'Sign up' : 'Sign in to your account';
    });

    const closeModal = () => {
      toggleAccountModal();
    };

    return {
      isAccountModalOpen,
      toggleAccountModal,
      isSignUp,
      toggleSignUp,
      closeModal,
      modalHeader,
    };
  },
});
